import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { useScrollbarWidth } from 'react-use/lib/useScrollbarWidth';
import { DIALOG_CONTAINER_ID } from 'theme';

import { cn } from '@lyearn/style';
import { Backdrop, Box } from '@lyearn/ui';

import { backdropWrapperStyles } from './styles';
import { CellBackdropProps } from './types';

function CellBackdrop(props: CellBackdropProps) {
  const { className = 'w-full h-full', children, disableWindowScroll, onClickAway } = props;
  const scrollbarWidth = useScrollbarWidth();
  const [ref, setRef] = useState<HTMLDivElement | null>(null);

  // todo need to optimize getBoundingClientRect on render will cause layout thrashing
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const rect = useMemo(() => ref?.getBoundingClientRect(), [ref]);

  useEffect(() => {
    if (!disableWindowScroll) {
      return;
    }

    document.body.style.overflow = 'hidden';
    document.body.style.paddingInlineEnd = `${scrollbarWidth}px`;

    return () => {
      document.body.style.overflow = 'auto';
      document.body.style.paddingInlineEnd = '0';
    };
  }, [disableWindowScroll, scrollbarWidth]);

  return (
    <Box ref={setRef} className={className}>
      {rect
        ? createPortal(
            <Box className={cn('fixed inset-0', backdropWrapperStyles)}>
              <Backdrop open className="bg-transparent" onClick={onClickAway} />
              {children(rect)}
            </Box>,
            document.getElementById(DIALOG_CONTAINER_ID)!,
          )
        : null}
    </Box>
  );
}

export default CellBackdrop;
